module.exports = __webpack_public_path__ + "static/media/nenad.b2ce2154.jpg";